import React, { useState, useEffect } from "react";
import "./css/BreakForShiftPopup.css";

export const BreakForShiftPopup = ({
  employee,
  initialBreak = null,
  editIndex = null,
  onSave,
  onClose,
}) => {
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");

  useEffect(() => {
    if (initialBreak) {
      setFromTime(initialBreak.from || "");
      setToTime(initialBreak.to || "");
    }
  }, [initialBreak]);

  const handleSave = (e) => {
    e?.preventDefault?.();
    if (!fromTime || !toTime) {
      alert("Du måste fylla i både starttid och sluttid.");
      return;
    }

    if (toTime <= fromTime) {
      alert("Sluttiden måste vara efter starttiden.");
      return;
    }

    const updatedBreak = { from: fromTime, to: toTime };

    // 👇 Pass editIndex if it's a valid number
    if (typeof editIndex === "number") {
      onSave(updatedBreak, editIndex);
    } else {
      onSave(updatedBreak);
    }

    onClose();
  };

  return (
    <div className="overtime-shift-popup__overlay">
      <div className="overtime-shift-popup">
        <h3 style={{ marginBottom: "15px" }}>
          {initialBreak?.from && initialBreak?.to
            ? `Redigera rast för ${employee?.name || "okänd"}`
            : `Lägg till rast för ${employee?.name || "okänd"}`}
        </h3>

        <div className="form-row" style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Starttid</label>
            <input type="time" value={fromTime} onChange={(e) => setFromTime(e.target.value)} />
          </div>

          <div className="form-group" style={{ flex: 1 }}>
            <label>Sluttid</label>
            <input type="time" value={toTime} onChange={(e) => setToTime(e.target.value)} />
          </div>
        </div>

        <div className="popup-actions" style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button className="primary-btn" onClick={(e) => handleSave(e)}>
            {initialBreak?.from && initialBreak?.to ? "Spara ändringar" : "Spara rast"}
          </button>
          <button className="secondary-btn" onClick={onClose}>
            Avbryt
          </button>
        </div>
      </div>
    </div>
  );
};

export default BreakForShiftPopup;
